import Vue from 'vue'
import {states} from './common-type.js'
import {format} from './utils.js'
//从common-type中获取数组
Vue.filter('switchType',function(value,sysm,str){
    let c = value;
    if(states[sysm][str]){
        states[sysm][str].map(v=>{
            if(v.code == value){
                c=v.value
            }
        })
    }
    return c
})
//传入的数组
Vue.filter('transState',function(str,arr,code,value){
    let s = str;
    let c = code || 'code';
    let l = value || 'value'
    if(Array.isArray(arr) && arr.length>0){
        arr.map(v=>{
            if(v[c] == str){
                s = v[l]
            }
        })
    }
    return s
})
//时间格式化
Vue.filter('formatDate', function (value,para) {
    if(!value || value == "") {
      return value
    }
    if(/\-/.test(value)) value = value.replace(/\-/g,"/");
    var para = para || 'YYYY-MM-DD hh:mm:ss'
    return format(new Date(value),para)
})
//钱 千分位 格式化
Vue.filter('currency',function(money){
    if(money && money!=null && /^(0|[1-9]\d*)(\.\d+)?$/.test(money)){
        money = String(money);
        var left=money.split('.')[0],right=money.split('.')[1];
        right = right ? (right.length>=2 ? '.'+right.substr(0,2) : '.'+right+'0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        return (Number(money)<0?"-":"") + temp.join(',').split('').reverse().join('')+right;
    }else{
        return '0.00';
    }
})

//单位过滤 添加小数点后三位 
Vue.filter('numberUnit',function(value){
    if(value && value!=null){
        value = String(value);
        let valArr = value.split('.');
        let left = valArr[0];
        let right = valArr[1] ? valArr[1].substring(0,3) : undefined;
        let s = valArr[1] ? valArr[1].substring(0,3) : 0;
        if(right){
            for(var i = 0; i < (3-s.length); i++){
                right += '0'
            }
        }
        return left + '.' + (right ? right : '000');
    }else{
        return '0.000';
    }
})


// WEBPACK FOOTER //
// ./src/server/filter.js